var islem = {
    topla: function (a,b) {
        return a + b;
    },
    cikar: function (a, b) {
        return a - b;
    },
    bol: function (a, b) {
        if (b != 0 && b > a) {
            return a / b;
        } else {
            return NaN 
        }      
        return NaN;
    },
    carp: function (a, b) {
        return a * b; 
    },
}